import { render, staticRenderFns } from "./orderNxshenpi.vue?vue&type=template&id=7c738b2f"
import script from "./orderNxshenpi.vue?vue&type=script&lang=js"
export * from "./orderNxshenpi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports